import React, { FC, useState } from 'react'

import { Translation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button'
import { TrainingCentreBreadcrumbs } from 'partner360/components/trainingCentre/components/trainingCentrePopup/components/trainingCentreBreadcrumbs/TrainingCentreBreadcrumbs'
import { TrainingCentreContent } from 'partner360/components/trainingCentre/components/trainingCentrePopup/components/trainingCentreContent/TrainingCentreContent'
import { TrainingCentreSearch } from 'partner360/components/trainingCentre/components/trainingCentrePopup/components/trainingCentreSearch/TrainingCentreSearch'
import { TRANSLATION_KEYS } from 'partner360/components/trainingCentre/translations'
import { ITrainingCentreData } from 'partner360/models/trainingCentre/ITrainingCentre'

import styles from './TrainingCentrePopup.module.scss'

interface ITrainingCentrePopupProps {
  data: ITrainingCentreData
  onClose: () => void
}

export const TrainingCentrePopup: FC<ITrainingCentrePopupProps> = ({ data, onClose }) => {
  const initialView = data.Rtms.length > 1 ? 'rtms' : 'topics'
  const initialRtm = data.Rtms.length === 1 ? data.Rtms[0].Rtm : null

  const [view, setView] = useState<'rtms' | 'topics' | 'topic'>(initialView)
  const [searchValue, setSearchValue] = useState('')
  const [selectedRtm, setSelectedRtm] = useState<string | null>(initialRtm)

  const [selectedTopicId, setSelectedTopicId] = useState<string | null>(null)

  const [expandedSections, setExpandedSections] = useState<string[]>([])

  const selectedTopicTitle = data.Topics.find((topic) => topic.Id === selectedTopicId)?.Title
  const shouldShowSearch = view === 'topics' || view === 'topic'
  const backToRtms = () => {
    setSelectedRtm(null)
    setSelectedTopicId(null)
    setExpandedSections([])
    setView('rtms')
  }

  const backToTopics = () => {
    setSelectedTopicId(null)
    setExpandedSections([])
    setView('topics')
  }

  const openRtm = (rtm: string) => {
    setSelectedRtm(rtm)
    setSelectedTopicId(null)
    setExpandedSections([])
    setView('topics')
  }

  const openTopic = (topicId: string) => {
    setSelectedTopicId(topicId)
    setExpandedSections([])
    setView('topic')
  }

  const toggleSection = (sectionTitle: string) => {
    setExpandedSections((prev) => {
      const isExpanded = prev.includes(sectionTitle)

      return isExpanded ? [] : [sectionTitle]
    })
  }

  return (
    <div className={styles.popup}>
      <div className={styles.header}>
        <h2 className={styles.title}>
          <Translation text={TRANSLATION_KEYS.title} />
        </h2>

        <Button iconButton="kbase kbase-close" onClick={onClose} variant={'text'} color={'grey'} />
      </div>

      {shouldShowSearch ? (
        <TrainingCentreSearch
          value={searchValue}
          onChange={setSearchValue}
          onClear={() => setSearchValue('')}
        />
      ) : null}
      <TrainingCentreBreadcrumbs
        view={view}
        selectedRtm={selectedRtm}
        selectedTopicTitle={selectedTopicTitle}
        canNavigateToRtms={data.Rtms.length > 1}
        onBackToRtms={backToRtms}
        onBackToTopics={backToTopics}
      />
      <div className={styles.scrollBody}>
        <TrainingCentreContent
          view={view}
          searchValue={searchValue}
          rtms={data.Rtms}
          topics={data.Topics}
          sections={data.Sections}
          selectedRtm={selectedRtm}
          selectedTopicId={selectedTopicId}
          expandedSections={expandedSections}
          onSelectRtm={openRtm}
          onSelectTopic={openTopic}
          onToggleSection={toggleSection}
        />
      </div>
    </div>
  )
}
